<template>
  <page-outline :title="$t('administration.company_add')">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutters">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-row>
      <form-accordion :title="$t('administration.company')" :isTitleUpperCase="false">
        <div class="form-group">
        </div>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="identifier" isMandatory
              :inputLabel="$t('administration.identifier')" :placeholderValue="$t('administration.identifier')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="name" isMandatory
              :inputLabel="$t('administration.company_name')" :placeholderValue="$t('administration.company_name')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="email_reference" isMandatory
              :inputLabel="$t('administration.user_email')" :placeholderValue="$t('administration.user_email')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <label>
              {{ $t('administration.active') }}
            </label>
            <select class="form-control" id="sel4" v-model="active" readonly>
              <option value="0"> {{ $t('administration.no') }} </option>
              <option value="1"> {{ $t('administration.in_prgrss') }} </option>
              <option value="2"> {{ $t('administration.yes') }} </option>
            </select>
          </b-col>
        </b-row>
      </form-accordion>
      <br>
      <form-accordion :title="$t('administration.user')" :isTitleUpperCase="false">
        <div class="form-group">
        </div>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="login" isMandatory
              :inputLabel="$t('administration.login')" :placeholderValue="$t('administration.login')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="username" isMandatory
              :inputLabel="$t('administration.username')" :placeholderValue="$t('administration.username')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <label>
              {{ $t('administration.active') }}
            </label>
            <select class="form-control" id="sel4" v-model="active_user" readonly>
              <option value="0"> {{ $t('administration.no') }} </option>
              <option value="1"> {{ $t('administration.in_prgrss') }} </option>
              <option value="2"> {{ $t('administration.yes') }} </option>
            </select>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="password"
              :inputLabel="$t('administration.password')" inputType="password" :placeholderValue="$t('administration.password')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>
      <br>
      <form-accordion :title="$t('administration.right')" :isTitleUpperCase="false">
        <div class="form-group">
        </div>
        <b-row>
          <b-col sm="6" lg="4" xl="3"  class="form-group" v-for="(result, id) in rights" :key="result + '-' + id">
            <b-form-checkbox v-model="select_rights" :value="result">
                {{ $t('rights.db_rights.' + result) === ('rights.db_rights.' + result) ? result : $t('rights.db_rights.' + result) }}
            </b-form-checkbox>
          </b-col>
        </b-row>
      </form-accordion>
      <b-row class="accordionForm form-group mt-3 justify-content-end no-gutters">
        <b-button variant="primary"
          @click="createCompany()">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"

import {loadPage} from '@/helpers/routing'
// import {validateAccountFormat, validateEmail, validateSIREN, validatePhoneNumber} from '@/helpers/validator'

export default {
  name: 'AddCompany',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton
  },
  data () {
    return {
      identifier: '',
      name: '',
      email_reference: '',
      active: '0',
      login: '',
      username: '',
      active_user: '0',
      password: '',
      rights: [],
      select_rights: [],
      redirection: this.$engine.firstOn().company.redirection,
      returnUrl: '/company/'
    }
  },
  created () {
    let that = this
    this.returnUrl = this.returnUrl + this.redirection
    that.makeRightsList()
  },
  methods: {
    makeRightsList () {
      let allStatus = Object.keys(this.$engine.firstOn().rights.getAll())
      let realStatusList = Object.keys(allStatus).filter(elem => allStatus[elem])
      this.rights = allStatus
    },
    createCompany () {
      let that = this
      let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      if (!this.identifier) {
        this.$f7.alert(that.$i18n.t('company.missing_company_identifier'), 'Error')
      } else if (!this.name) {
        that.$f7.alert(that.$i18n.t('company.missing_company_name'), 'Error')
      } else if (!this.email_reference) {
        that.$f7.alert(that.$i18n.t('company.missing_company_email'), 'Error')
      } else if (!this.login) {
        that.$f7.alert(that.$i18n.t('company.missing_login'), 'Error')
      } else if (!this.username) {
        that.$f7.alert(that.$i18n.t('usercompany.missing_name'), 'Error')
      } else if (!this.password) {
        that.$f7.alert(that.$i18n.t('company.missing_password'), 'Error')
      } else if (!regexPassword.test(this.password)) {
        that.$f7.alert(that.$i18n.t('profilesPage.password_wrong_format'), 'Error')
      } else if (this.select_rights.length <= 0) {
        that.$f7.alert(that.$i18n.t('company.missing_rights'), 'Error')
      } else {
        this.$engine.firstOn().company.addCompany(
          {
            identifier: this.identifier,
            name: this.name,
            email_reference: this.email_reference,
            active: this.active
          },
          {
            login: this.login,
            name: this.username,
            password: this.password,
            active: this.active_user
          },
          this.select_rights
        ).then(resp => {
          that.$f7.modal({
            title: that.$i18n.t('administration.user_added'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: '/company/' + that.redirection})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.$f7.modal({
            title: that.$i18n.t('administration.user_addition_error'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
        })

      }
    }
  }
}
</script>
